import {
  ACCOUNT_COMPLETE_TUTORIAL,
  ACCOUNT_CURRENT_SUCCESS,
  ACCOUNT_GET_INTEGRATIONS_SUCCESS,
  ACCOUNT_PUT_SUCCESS,
  ACCOUNT_UPDATE_SUCCESS,
} from 'redux/constants/Accounts';
import {BILLING_UPDATE_SUCCESS} from 'redux/constants/Billing';
import {
  ACCOUNT,
  AUTH_TOKEN,
  AUTHENTICATED,
  HIDE_AUTH_MESSAGE,
  HIDE_LOADING,
  SHOW_AUTH_MESSAGE,
  SHOW_LOADING,
  SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
  SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SIGNOUT_SUCCESS,
  SIGNUP_SUCCESS,
  TUTORIAL,
  UPDATE_AVATAR,
  UPDATE_CURRENT_USER,
  USER,
} from '../constants/Auth';

const initState = {
  loading: false,
  message: '',
  showMessage: false,
  redirect: '',
  token: localStorage.getItem(AUTH_TOKEN),
  user: localStorage.getItem(USER)
    ? JSON.parse(localStorage.getItem(USER))
    : {
        name: null,
        avatar: null,
        id: null,
        dark_theme: false,
      },
  account: localStorage.getItem(ACCOUNT)
    ? JSON.parse(localStorage.getItem(ACCOUNT))
    : {
        created_at: null,
        id: null,
        name: null,
        stripe_customer_id: null,
        tax_rate: null,
        updated_at: null,
      },
  tutorial: localStorage.getItem(TUTORIAL)
    ? JSON.parse(localStorage.getItem(TUTORIAL))
    : null,
  currentAccount: null,
  integrations: null,
};

const auth = (state = initState, action) => {
  switch (action.type) {
    case AUTHENTICATED:
      return {
        ...state,
        loading: false,
        redirect: '/app/home',
        token: action.token,
        user: action.user,
        account: action.account,
        tutorial: action.tutorial,
      };
    case UPDATE_CURRENT_USER:
      return {
        ...state,
        user: action.user,
      };
    case UPDATE_AVATAR:
      return {
        ...state,
        user: {
          ...state.user,
          avatar: action.avatar,
        },
      };
    case SHOW_AUTH_MESSAGE:
      return {
        ...state,
        message: action.message,
        showMessage: true,
        loading: false,
      };
    case HIDE_AUTH_MESSAGE:
      return {
        ...state,
        message: '',
        showMessage: false,
      };
    case SIGNOUT_SUCCESS: {
      return {
        ...state,
        token: null,
        user: {
          name: null,
          avatar: null,
          id: null,
          dark_theme: false,
        },
        redirect: '/auth/login',
        loading: false,
      };
    }
    case SIGNUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        token: action.token,
        user: action.user,
        account: action.account,
        tutorial: action.tutorial,
      };
    }
    case SHOW_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case HIDE_LOADING: {
      return {
        ...state,
        loading: false,
      };
    }
    case SIGNIN_WITH_GOOGLE_AUTHENTICATED: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case SIGNIN_WITH_FACEBOOK_AUTHENTICATED: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case ACCOUNT_UPDATE_SUCCESS: {
      return {
        ...state,
        account: action.account,
      };
    }
    case ACCOUNT_PUT_SUCCESS: {
      return {
        ...state,
        account: action.account,
      };
    }
    case ACCOUNT_CURRENT_SUCCESS: {
      return {
        ...state,
        currentAccount: action.account,
      };
    }
    case ACCOUNT_GET_INTEGRATIONS_SUCCESS: {
      return {
        ...state,
        integrations: action.integrations,
      };
    }
    case BILLING_UPDATE_SUCCESS: {
      return {
        ...state,
        account: action.data,
      };
    }
    case ACCOUNT_COMPLETE_TUTORIAL: {
      return {
        ...state,
        tutorial: null,
      };
    }
    default:
      return state;
  }
};

export default auth;
